import objects from '~/utils/objects';

import type { PersonAPI } from './person-api.types';

import http from './person-api.http';
import { mapPartnerUsersListResponse } from './person-api.partner-users.utils';

const PARTNER_USERS_LIST_HEADERS = {
  'Cache-Control': 'no-cache',
};

export default {
  healthcheck: async () => {
    const res = await http.get('/healthcheck/');
    return res.data;
  },

  metrics: async () => {
    const res = await http.get('/metrics/');
    return res.data;
  },

  partner: {
    emailInUse: async (email: string) => {
      const res = await http.get(`/partner/email-in-use/${email}`);
      return res.data;
    },

    getById: async ({ partner_id: partnerId, ...rest }: PersonAPI.GetPartnerParams) => {
      const qp = objects.buildQueryParamsString(rest);
      const res = await http.get(`/partner/${partnerId}${qp ? `?${qp}` : ''}`);
      return res.data as PersonAPI.GetPartnerByIdResponse;
    },

    getSignedOperatingAgreement: async (partnerId: number) => {
      const res = await http.get(`/partner/${partnerId}/operating-agreement/signed`);
      return res.data as PersonAPI.GetSignedOperatingAgreementResponse;
    },

    list: async (params?: PersonAPI.ListPartnersParams) => {
      const qp = objects.buildQueryParamsString(params || {});
      const res = await http.get(`/partner${qp ? `?${qp}` : ''}`);
      return res.data;
    },

    phoneInUse: async (phone: string) => {
      const res = await http.get(`/partner/phone-in-use/${phone}`);
      return res.data;
    },

    users: async ({ partner_id: partnerId, ...rest }: PersonAPI.ListPartnerUsersParams) => {
      const qp = objects.buildQueryParamsString(rest);
      const res = await http.get<PersonAPI.PartnerUsersListResponseHttp>(
        `/partner/${partnerId}/user${qp ? `?${qp}` : ''}`,
        { headers: PARTNER_USERS_LIST_HEADERS },
      );
      const page = rest.page ?? 1;
      const pageSize = rest.page_size ?? 10;

      return mapPartnerUsersListResponse(res.data, page, pageSize);
    },
  },

  roles: {
    distribution: async (params: PersonAPI.GetRolesDistributionParams) => {
      const qp = objects.buildQueryParamsString(params);
      const res = await http.get(`/roles/distribution${qp ? `?${qp}` : ''}`);
      return res.data;
    },
  },

  user: {
    getById: async (id:string, params?: PersonAPI.UserParams) => {
      const qp = objects.buildQueryParamsString(params);
      const res = await http.get<PersonAPI.UserResponse>(`/user/${id}${qp ? `?${qp}` : ''}`, {
        headers: {
          ...params?.clear_cache && { 'Cache-Control': 'no-cache' },
        },
      });
      return res.data;
    },

    getMe: async (params?: PersonAPI.GetUserMeRequestParams) => {
      const qp = objects.buildQueryParamsString(params || {});
      const res = await http.get(`/user/me${qp ? `?${qp}` : ''}`);
      return res.data;
    },

    list: async (params?: PersonAPI.UsersRequestParams) => {
      const qp = objects.buildQueryParamsString(params || {});
      const res = await http.get<PersonAPI.UsersResponse>(`/user${qp ? `?${qp}` : ''}`);
      return res.data;
    },

    partners: async ({ user_id: userId, ...rest }: PersonAPI.ListUserPartnersParams) => {
      const qp = objects.buildQueryParamsString(rest);
      const res = await http.get(`/user/${userId}/partner${qp ? `?${qp}` : ''}`);
      return res.data;
    },
  },
};
